import Backtop from './src/backtop2.mjs';
export { backtopEmits, backtopProps } from './src/backtop.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElBacktop = withInstall(Backtop);

export { ElBacktop, ElBacktop as default };
//# sourceMappingURL=index.mjs.map
